module.exports = __webpack_public_path__ + "img/IMG_9435.edafc25d.jpg";